import { render, staticRenderFns } from "./AccordionParser.vue?vue&type=template&id=790f46de"
import script from "./AccordionParser.vue?vue&type=script&lang=js"
export * from "./AccordionParser.vue?vue&type=script&lang=js"
import style0 from "./AccordionParser.vue?vue&type=style&index=0&id=790f46de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports